export const LOG_DEBUG = 'debug';
export const LOG_ERROR = 'error';
export const LOG_INFO = 'info';
export const LOG_LOG = 'log';
export const LOG_TRACE = 'trace';
export const LOG_WARN = 'warn';

/**
 * Logger lets us add custom logging logic if we like
 *
 * @param logLevel
 * @param args
 * @constructor
 */
export const Logger = ( logLevel, ...args ) => {

    switch ( logLevel ) {
        case LOG_DEBUG:
            console.debug( ...args );
            break;
        case LOG_ERROR:
            console.error( ...args );
            break;
        case LOG_INFO:
            console.info( ...args );
            break;
        case LOG_TRACE:
            console.trace( ...args );
            break;
        case LOG_WARN:
            console.warn( ...args );
            break;
        default:
            console.log( args );
    }
};